import request from '@/utils/request'
// 子订单列表
export function getSubOrderList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/list',
    method: 'post',
    data,
  })
}
// 子订单详情--订单信息
export function getSubOrderDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/detail',
    method: 'post',
    data,
  })
}

// 批量退车根据车辆id回显详情
export function getCarDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/returnable/car/detail',
    method: 'post',
    data,
  })
}
// 采购订单退车结算信息详情
export function getSettlementDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/detail',
    method: 'post',
    data,
  })
}
// 采购子订单退车核算 --- 提交
export function confirmSettlementSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/v2/submit',
    method: 'post',
    data,
    signParams: [
      'orderId',
      'refundableDepositAmount',
      'refundableRentAmount',
      'needPatchAmount',
      'payDepositAmount',
      'paidDepositAmount',
      'payAmount',
      'paidAmount',
    ],
  })
}
// 采购子订单退车核算 --- 保存
export function saveSettlementSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/v2/save',
    method: 'post',
    data,
    signParams: [
      'orderId',
      'refundableDepositAmount',
      'refundableRentAmount',
      'needPatchAmount',
      'payDepositAmount',
      'paidDepositAmount',
      'payAmount',
      'paidAmount',
    ],
  })
}
// 采购子订单结算应收应退金额计算
export function calculateCarAmount(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/calculate',
    method: 'post',
    data,
  })
}

// 子订单新增车辆
export function purchaseSubAddSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/v2/add',
    method: 'post',
    data,
    signParams: ['purchaseOrderId', 'providerId', 'carList[0].id', 'carList[0].modelId'],
  })
}

// 采购子订单统计
export function purchaseSubSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/summary',
    method: 'post',
    data,
  })
}

// 采购子订单统计
export function purchaseCarAddImport(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/car/import',
    method: 'post',
    data,
  })
}

// 批量退车上传文件
export function carImportant(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/returnable/car/import',
    method: 'post',
    data,
  })
}

// 批量退车上传文件
export function returnableCarList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/returnable/car/list',
    method: 'post',
    data,
  })
}

// 支付计划列表
export function planList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/plan/detail',
    method: 'post',
    data,
  })
}

// 支付计划-查看应收单详情
export function paymentDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/payment/detail',
    method: 'post',
    data,
  })
}

// 支付计划-查看应收单详情
export function purchaseCloseOrder(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/close',
    method: 'post',
    data,
  })
}
